import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language || 'en';

  return (
    <div className="flex items-center space-x-1 bg-pastel-purple-50 dark:bg-gray-800 rounded-lg p-1">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${
          currentLanguage === 'en'
            ? 'bg-white dark:bg-gray-700 text-pastel-purple-600 dark:text-pastel-purple-400 shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-pastel-purple-600 dark:hover:text-pastel-purple-400'
        }`}
        title="English"
      >
        EN
      </button>
      <button
        onClick={() => changeLanguage('pl')}
        className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${
          currentLanguage === 'pl'
            ? 'bg-white dark:bg-gray-700 text-pastel-purple-600 dark:text-pastel-purple-400 shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-pastel-purple-600 dark:hover:text-pastel-purple-400'
        }`}
        title="Polski"
      >
        PL
      </button>
    </div>
  );
};

export default LanguageSwitcher;
